import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DashboardLeadsFocused from '../../../mogul/components/DashboardLeadsFocused'
import MogulHeader from '../../../mogul/components/MogulHeader'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
]

const DashboardPage = () => {

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  useEffect(() => {
    // if local, show events_administrators on load:
    // if (window.location.hostname === 'localhost') {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
  }, [])

  return (
    <>
      <MogulHeader title='Lead Analytics Dashboard' />
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8' style={{ height: 'calc(100vh - 200px)' }}>
        {/* begin::Col */}
        <div className='col-xxl-12 h-100'>
          <DashboardLeadsFocused />
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
